import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, EMPTY } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { VersionCheckService } from './services/version-check.service';

@Injectable()
export class VersionCheckInterceptor implements HttpInterceptor {
  constructor(private versionCheck: VersionCheckService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // Only gate outgoing API calls — skip the version check endpoint, login, and static files.
    if (!req.url.includes('/charitycentral/') ||
        req.url.includes('/charitycentral/checkversion') ||
        req.url.includes('/charitycentral/login')) {
      return next.handle(req);
    }

    return this.versionCheck.checkVersionIfNeeded().pipe(
      switchMap(ok => ok ? next.handle(req) : EMPTY)
    );
  }
}
